import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

// Add custom prop typing
interface StyledDividerProps {
  isToapplyV2Theme?: boolean;
}

// Styled component with custom prop handling
export const StyledDivider = styled(Divider, {
  shouldForwardProp: (prop) => prop !== 'isToapplyV2Theme',
})<StyledDividerProps>(({ theme, isToapplyV2Theme }) => ({
  background: isToapplyV2Theme ? theme.palette.divider : theme.palette.themeColorSecondary.main,
  width: '238px',
  height: '3px',
  borderRadius: '4px',
  marginBlock: '0.5rem',
}));

export const StTextContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    maxWidth: '330px',
    '.MuiTypography-root': {
      fontSize: '1.5rem',
    },
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: '550px',
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '630px',
  },
}));
